import React, { useState, useEffect, useRef } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../../components/mensajes';
import CartasFinanza from './cartas';
import { formatMoneda, validaSoloNumero, validaMonto, formatoMonto } from '../../util/varios';
import moment from 'moment';
import CatalogoCuentaBancaria from '../../catalogos/catalogoCuentasBancarias';

const TablaConciliacion = () => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  let anio = JSON.parse(sessionStorage.getItem('anioactu'));
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'))

  const accbtncnciliabancaria = JSON.parse(sessionStorage.getItem('accbtncnciliabancariac'));
  const fechaTope = moment(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const chkNatural = useRef();
  const chkJuridico = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtRazon = useRef();
  const txtDirClient = useRef();
  const txtEmailClient = useRef();
  const txtTlf1Client = useRef();
  const txtTlf2Client = useRef();
  const txtId = useRef();
  const txtDescripcion = useRef();
  const chkSi = useRef();
  const chkNo = useRef();
  const chkDepositos = useRef();
  const txtNombre = useRef();
  const txtNCuenta = useRef();
  const txtSucursal = useRef();
  const txtPersona = useRef();
  const txtTelefono = useRef();
  const txtPrepuesto = useRef();
  const txtDireccion = useRef();
  const txtSaldoCon = useRef();
  const txtSaldoLib = useRef();
  const txtConcepto = useRef();
  const txtPorcenDeb = useRef();
  const txtEmision = useRef();
  const cmbNacionalidad = useRef();
  const txtCedRes = useRef();
  const cmbSexo = useRef();
  const txtFechaNac = useRef();
  const txtNomResp = useRef();
  const txtApeResp = useRef();
  const txtEmail = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();

  const [operacion, setOperacion] = useState(1);
  const [bancos, setBancos] = useState()
  const [idBanco, setIdBanco] = useState()
  const [visibleBtn, setVisibleBtn] = useState('visible')
  const [habilitado, setHabilitado] = useState(true);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);

  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [titleCed, setTitleCed] = useState('Cédula:');
  const [cmbCedula, setCmbCedula] = useState([{ value: 'V' }, { value: 'E' }]);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true
  });
  const [values, setValues] = useState({
    idcuentabancaria: '',
    nombre: '',
    cuentabancaria: '',
    sucursal: '',
    direccion: '',
    contacto: '',
    telefono: '',
    presupuesto: '',
    saldoconcil: '',
    saldolib: '',
    codctacont: '',
    tipo: '',
    concepto: '',
    debitobanc: '',
    porcentdebito: '',
    codctadebitobanc: '',
    idorganizacion: '',
    idefiscal: '',
    idbanco: '',
    caduca: '',
    idcuentacontable: '',
    depositoweb: '',
    activo: ''
  });

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;//alert(e.which);
  };

  const [ciudades, setCiudades] = useState();
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [operacionPer, setOperacionPer] = useState(0);

  const datosRes = () => {
    let campos = '*';
    let nomtab = 'persona';
    let nomid = 'cedula';
    let nomid2 = 'nacionalidad';
    let id = txtCedRes.current.value;
    let id2 = cmbNacionalidad.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        cmbSexo.current.value = ''
        txtFechaNac.current.value = ''
        txtNomResp.current.value = ''
        txtApeResp.current.value = ''
        txtDireccion.current.value = ''
        txtEmail.current.value = ''
        txtTlf1.current.value = ''
        txtTlf2.current.value = ''

        if (response.data !== '') {
          setHabilitadoNU(true);
          setOperacionPer(0);
          cmbSexo.current.value = response.data.sexo
          txtFechaNac.current.value = moment(response.data.fnacimiento).format('YYYY-MM-DD')
          txtNomResp.current.value = response.data.nombres
          txtApeResp.current.value = response.data.apellidos
          txtDireccion.current.value = response.data.direccion
          txtEmail.current.value = response.data.correoe
          txtTlf1.current.value = response.data.tlf1
          txtTlf2.current.value = response.data.tlf2
          if (!botones.consultar) {
            btnCancela.current.focus();
          } else {
            btnAcepta.current.focus();
          }

        } else {
          txtNomResp.current.focus();
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una persona con este N° de cedula porfavor registre sus datos', icono: 'informacion' });
          setOperacionPer(1);
          setHabilitadoNU(false);

        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const selectCiudad = (id) => {
    let campos = '*';
    let nomtab = 'ciudad';
    let nomid = 'idmunicipio';
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        setCiudades(response.data)
      }
    }).catch(function (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const idbancio = (id) => (e) => {
    e.preventDefault()
    setIdBanco(id)
  }
  const blanquear = () => {
    setOperacionPer(0);
    setHabilitado(true);
    setHabilitadoNU(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoper: true
    });
    chkSi.current.checked = false;
    chkNo.current.checked = false;
    setValues({
      idcuentabancaria: '',
      nombre: '',
      cuentabancaria: '',
      sucursal: '',
      direccion: '',
      contacto: '',
      telefono: '',
      presupuesto: '',
      saldoconcil: '',
      saldolib: '',
      codctacont: '',
      tipo: '',
      concepto: '',
      debitobanc: '',
      porcentdebito: '',
      codctadebitobanc: '',
      idorganizacion: '',
      idefiscal: '',
      idbanco: '',
      caduca: '',
      idcuentacontable: '',
      depositoweb: '',
      activo: ''
    })
    txtId.current.value = '';
    txtDireccion.current.value = ''
    setVisibleBtn('visible')
    chkDepositos.current.checked = false
    setActivate(false);



  }


  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/banco/actualizarcuentabancaria`;

    let body;

    body = {
      operacion: ope,
      nid: values.idcuentabancaria !== '' ? parseInt(values.idcuentabancaria) : 0,
      nombanc: values.nombre.trim(),
      nrocuent: values.cuentabancaria.trim(),
      sucur: values.sucursal.trim(),
      dir: values.direccion.trim(),
      cont: values.contacto.trim(),
      telf: values.telefono.trim(),
      presu: values.presupuesto.trim(),
      salconc: txtSaldoCon.current.value !== '' ? parseFloat(txtSaldoCon.current.value.replace(/\./g, '').replace(',', '.')) : '0.00',
      sallib: txtSaldoLib.current.value !== '' ? parseFloat(txtSaldoLib.current.value.replace(/\./g, '').replace(',', '.')) : '0.00',
      ctacont: null,
      tip: null,
      concep: values.concepto.trim(),
      impdeb: chkSi.current.checked ? true : false,
      porc: txtPorcenDeb.current.value !== '' ? parseFloat(txtPorcenDeb.current.value.replace(/\./g, '').replace(',', '.')) : '0.00',
      ctacontdeb: null,
      org: operacion === 1 ? 1 : values.idorganizacion.trim(),
      efis: values.idefiscal !== '' ? values.idefiscal : 1,
      idban: parseInt(idBanco),
      cadu: values.caduca === '' ? 60 : parseInt(values.caduca),
      idcta: null,
      depweb: chkDepositos.current.checked === true ? true : false,
      idctanota: null,
      idctatransfe: null
    }

    axios.post(endpoint, body, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (ope === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
        } else if (ope === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
        } else if (ope === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
        }
        txtNCuenta.current.value = ''
        txtSucursal.current.value = ''
        txtPersona.current.value = ''
        txtTelefono.current.value = ''
        txtPrepuesto.current.value = ''
        txtSaldoCon.current.value = ''
        txtSaldoLib.current.value = ''
        txtConcepto.current.value = ''
        txtPorcenDeb.current.value = ''
        txtEmision.current.value = ''
        blanquear()

        setActivate(false);
      }
    }).catch(function (error) {
      let mensaje = '';
      if (error.response === undefined) {
        mensaje = 'Error de Conexion'
      } else {
        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
          mensaje = 'Ya existe un Registro'

        }
        else {
          mensaje = error.response.data.message
        }
      }
      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
      setActivate(false);
    })
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
        event.target.value = '0,00'
      }
      event.target.value = (formatoMonto(event.target.value));
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === '0' && char2 !== ',') {
        event.target.value = event.target.value.substring(1, event.target.value.legth);
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    procesarRegistro();


  };

  const onChange = (e) => {

    if (event.target.name === 'direccion' || event.target.name === 'sucursal' || event.target.name === 'contacto' || event.target.name === 'concepto') {
      event.target.value = event.target.value.toUpperCase();
      setValues({ ...values, [event.target.name]: event.target.value.toUpperCase() });
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  }

  const seleccionarRegistro = () => {
    let campos = '*';
    let nomtab = 'cuentabancaria';
    let nomid = 'idcuentabancaria';
    let id = txtId.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {



        if (response.data !== '') {

          setValues(response.data)
          txtDireccion.current.value = response.data.direccion.trim()
          if (response.data.debitobanc) {
            chkSi.current.checked = true;
          } else {
            chkNo.current.checked = true;
          }
          if (response.data.depositoweb) {
            chkDepositos.current.checked = true
          }

          /*        if(response.data) */
        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una marca con este codigo', icono: 'informacion' });
          txtDescripcion.current.value = '';
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {

        seleccionarRegistro();

      } else {
        chkSi.current.checked = false;
        chkNo.current.checked = false;
        txtDireccion.current.value = ''
        setValues({
          idcuentabancaria: '',
          nombre: '',
          cuentabancaria: '',
          sucursal: '',
          direccion: '',
          contacto: '',
          telefono: '',
          presupuesto: '',
          saldoconcil: '',
          saldolib: '',
          codctacont: '',
          tipo: '',
          concepto: '',
          debitobanc: '',
          porcentdebito: '',
          codctadebitobanc: '',
          idorganizacion: '',
          idefiscal: '',
          idbanco: '',
          caduca: '',
          idcuentacontable: '',
          depositoweb: '',
          activo: ''
        })
        txtId.current.value = '';
      }
    }
  };


  /* 
    const onCatalogoCliente = (values) => {
      setCatalogoCliente(false);
      txtRazon.current.value = values.nombre;
      cmbRif.current.value = values.rif.substring(0, 1);
      txtRif.current.value = values.rif.substring(1, 8);
      datosRes();
      if (!botones.modificar) {
        setBotones({ ...botones, catalogoper: false });
      }
    } */
  /* 
    const onCatalogoPersona = (cedPer, nomPer, apePer, correoPer, tlf1Per,
      tlf2Per, fnacPer, nacPer, sexoPer, direPer) => {
      setCatalogoPersona(false);
      setHabilitadoNU(true);
      setOperacionPer(0);
      cmbNacionalidad.current.value = nacPer;
      txtCedRes.current.value = cedPer;
      cmbSexo.current.value = sexoPer;
      txtFechaNac.current.value = moment(fnacPer).format('YYYY-MM-DD');
      txtNomResp.current.value = nomPer;
      txtApeResp.current.value = apePer;
      txtDireccion.current.value = direPer;
      txtEmail.current.value = correoPer;
      txtTlf1.current.value = tlf1Per;
      txtTlf2.current.value = tlf2Per;
    }
   */
  const onChangeValidar = () => {

    let sigue = true;

    if (!botones.incluir || !botones.modificar) {

      if (txtNombre.current.value === '' || txtNCuenta.current.value === '' || txtSucursal.current.value === '' || txtPersona.current.value === '' || txtTelefono.current.value === '' || txtPrepuesto.current.value === '' || txtDireccion.current.value === '' || txtSaldoCon.current.value === '' || txtSaldoLib.current.value === '' || txtConcepto.current.value === '') {

        let mensaje = '';

        { txtNombre.current.value === '' ? mensaje = 'el Nombre' : txtNCuenta.current.value === '' ? mensaje = 'la Cuenta' : txtSucursal.current.value === '' ? mensaje = 'la Sucursal' : txtPersona.current.value === '' ? mensaje = 'la Persona de Contacto' : txtTelefono.current.value === '' ? mensaje = 'el Telefono' : txtPrepuesto.current.value === '' ? mensaje = 'si es Presupuesto' : txtDireccion.current.value === '' ? mensaje = 'la Dirección' : txtSaldoCon.current.value === '' ? mensaje = 'el Saldo Conciliado' : txtSaldoLib.current.value === '' ? mensaje = 'Saldo en Libros' : txtConcepto.current.value === '' ? mensaje = 'Concepto' : '' }

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar Correctamente ' + mensaje + '.', icono: 'informacion' });

        { txtNombre.current.value === '' ? txtNombre.current.focus() : txtNCuenta.current.value === '' ? txtNCuenta.current.focus() : txtSucursal.current.value === '' ? txtSucursal.current.focus() : txtPersona.current.value === '' ? txtPersona.current.focus() : txtTelefono.current.value === '' ? txtTelefono.current.focus() : txtPrepuesto.current.value === '' ? txtPrepuesto.current.focus() : txtDireccion.current.value === '' ? txtDireccion.current.focus() : txtSaldoCon.current.value === '' ? txtSaldoCon.current.focus() : txtSaldoLib.current.value === '' ? txtSaldoLib.current.focus() : txtConcepto.current.value === '' ? txtConcepto.current.focus() : btnAcepta.current.focus() }

        sigue = false;

      }
    }
    if (sigue) {

      let msg = '';
      if (!botones.incluir) {
        msg = 'Esta Seguro de Registrar estos Datos.';
      } else if (!botones.modificar) {
        msg = 'Esta Seguro de Modificar estos Datos.';
      } else if (!botones.eliminar) {
        msg = 'Esta Seguro de Eliminar estos Datos.';
      }

      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });


    }

  }

  const seleccionarRegistros = () => {

    let campos = '*';
    let nomtab = 'bancos';
    let orden = 'idbanco';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {
          setBancos(response.data);

        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  const onCatalogoCuenta = (values) => {
    setCatalogoCuenta(false);
    chkSi.current.checked = false;
    chkNo.current.checked = false;
    setValues({
      idcuentabancaria: '',
      nombre: '',
      cuentabancaria: '',
      sucursal: '',
      direccion: '',
      contacto: '',
      telefono: '',
      presupuesto: '',
      saldoconcil: '',
      saldolib: '',
      codctacont: '',
      tipo: '',
      concepto: '',
      debitobanc: '',
      porcentdebito: '',
      codctadebitobanc: '',
      idorganizacion: '',
      idefiscal: '',
      idbanco: '',
      caduca: '',
      idcuentacontable: '',
      depositoweb: '',
      activo: ''
    })
    txtId.current.value = '';
    setValues(values)
    txtDireccion.current.value = values.direccion
    if (values.debitobanc) {
      chkSi.current.checked = true;
    } else {
      chkNo.current.checked = true;
    }
    if (values.depositoweb) {
      chkDepositos.current.checked = true
    }
    txtId.current.value = values.idcuentabancaria

  }

  const onBotones = (op) => (e) => {

    e.preventDefault();

    if (op === 1) {

      if (accbtncnciliabancaria && accbtncnciliabancaria.toString().substring(0, 1) === '1') {
        setVisibleBtn('hidden');
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoper: false
        });
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 2) {

      if (accbtncnciliabancaria && accbtncnciliabancaria.toString().substring(1, 2) === '1') {
        setVisibleBtn('hidden');
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 3) {

      if (accbtncnciliabancaria && accbtncnciliabancaria.toString().substring(3, 4) === '1') {
        setVisibleBtn('hidden');
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 4) {

      if (accbtncnciliabancaria && accbtncnciliabancaria.toString().substring(2, 3) === '1') {
        setVisibleBtn('hidden');
        setHabilitado(true);
        txtId.current.focus()
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setVisibleBtn('visible');
      blanquear();
    }
  }


  useEffect(() => {
    seleccionarRegistros()

  }, []);


  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div className="row col-md-12 py-5" style={{ margin: 0 }}>
        <div className='row col-md-12 py-2' style={{ margin: 0 }}>
          <div className='col-md-8 border-azul rounded py-2 row mx-auto azulGradiant shadow text-light justify-content-between'>
            <div className='col-md-6'>

              <h3>
                Gestion de Conciliaciones Bancarios
              </h3>


            </div>
            <div className='col-md-3 d-flex justify-content-end'>

              <a href='/inicio' className='text-light '><i className="fas fa-times mx-2"></i><span className='fw-bold'>Salir</span></a>

            </div>
          </div>
          <div className='col-md-8 py-3 mx-auto card shadow '>

            <div className='col-md-12 row mx-auto  rounded py-2' style={{ fontSizeAdjust: '0.6' }}>
              <div className='col-md-12 mx-auto d-flex justify-content-end'>
                <div className=" d-flex justify-content-end col-md-4">
                  <span >Fecha de Conciliación: <span className='fw-bold'>{moment(fechasistema).format('YYYY-MM-DD')} </span></span>
                </div>
              </div>

              <div className='row mx-auto'>



                <div className='col-md-12 mb-2'>
                  <fieldset className=' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between'>
                    <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Datos Bancarios</legend>

                    <div className="input-group input-group-sm mb-2 col-md-12">
                      <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO:</label>

                      <input type="text" className="form-control bg-light col-md-1 fs-6" placeholder='Cod.' disabled ref={txtId} defaultValue={values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : ''} onKeyUp={validarCuenta} onBlur={validarCuenta} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                      <button type="button" disabled={botones.catalogo} onClick={() => { setCatalogoCuenta(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>
                      <input type="text" className="form-control bg-light col-md-3 fs-6" placeholder='0000-000000-00000000000' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                      <input type="text" className="form-control bg-light fs-6" disabled placeholder='Nombre' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                    </div>

                  </fieldset>
                </div>
                <div className='col-md-12 mb-2'>
                  <fieldset className=' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between'>
                    <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Periodo a Conciliar</legend>

                    <div className="input-group input-group-sm mb-2 col-md-2">
                      <label className="input-group-text" id="inputGroup-sizing-sm">MES:</label>
                      <select className="form-select form-select-sm text-uppercase" aria-label=".form-select-sm example" onChange={onChange} >
                        <option value="">--</option>
                        <option value="V">V</option>
                        <option value="E">E</option>
                      </select>

                    </div>
                    <div className="input-group input-group-sm mb-2 col-md-2">
                      <label className="input-group-text" id="inputGroup-sizing-sm">DIA:</label>
                      <select className="form-select form-select-sm text-uppercase" aria-label=".form-select-sm example" onChange={onChange} >
                        <option value="">--</option>
                        <option value="V">V</option>
                        <option value="E">E</option>
                      </select>

                    </div>
                    <div className="input-group input-group-sm mb-2 col-md-2">
                      <label className="input-group-text" id="inputGroup-sizing-sm">AÑO:</label>
                      <select className="form-select form-select-sm text-uppercase" aria-label=".form-select-sm example" onChange={onChange} >
                        <option value="">--</option>
                        <option value="V">V</option>
                        <option value="E">E</option>
                      </select>

                    </div>
                    <div className='col-md-1'></div>
                    <div className="input-group input-group-sm mb-2 col-md-3">
                      <label className="input-group-text" id="inputGroup-sizing-sm">TIPO MOVIMIENTO:</label>
                      <select className="form-select form-select-sm text-uppercase" aria-label=".form-select-sm example" onChange={onChange} >
                        <option value="">--</option>
                        <option value="V">V</option>
                        <option value="E">E</option>
                      </select>

                    </div>
                    <div className="input-group input-group-sm mb-2 col justify-content-end">
                      <button type="button" className="btn btn-success rounded"><i className="fas fa-search">Buscar</i></button>
                    </div>



                  </fieldset>
                </div>
                <div className='col-md-12 mb-2'>
                  <fieldset className=' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between'>
                    <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>SALDOS EN CUENTA</legend>


                    <div className="input-group input-group-sm mb-2 col-md-3">
                      <label className="input-group-text" id="inputGroup-sizing-sm">SALDO ANTERIOR:</label>

                      <input type="text" className="form-control bg-light text-right fs-6" placeholder='0,00' disabled ref={txtId} defaultValue={values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : ''} onKeyUp={validarCuenta} onBlur={validarCuenta} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                    </div>
                    <div className="input-group input-group-sm mb-2 col-md-3">
                      <label className="input-group-text" id="inputGroup-sizing-sm">DEBITO:</label>

                      <input type="text" className="form-control bg-light text-right fs-6" placeholder='0,00' disabled ref={txtId} defaultValue={values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : ''} onKeyUp={validarCuenta} onBlur={validarCuenta} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                    </div>

                    <div className="input-group input-group-sm mb-2 col-md-3">
                      <label className="input-group-text" id="inputGroup-sizing-sm">CREDITO:</label>

                      <input type="text" className="form-control bg-light text-right fs-6" placeholder='0,00' disabled ref={txtId} defaultValue={values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : ''} onKeyUp={validarCuenta} onBlur={validarCuenta} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                    </div>

                    <div className="input-group input-group-sm mb-2 col-md-3">
                      <label className="input-group-text" id="inputGroup-sizing-sm">SALDO ACTUAL:</label>

                      <input type="text" className="form-control bg-light text-right fs-6" placeholder='0,00' disabled ref={txtId} defaultValue={values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : ''} onKeyUp={validarCuenta} onBlur={validarCuenta} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                    </div>


                  </fieldset>
                </div>

                <div className='col-md-12 mx-auto'>
                  <ul className="nav mb-2" id="ex-with-icons" role="tablist">
                    <li className="nav-item" role="presentation">
                      <a style={{ pointerEvents: botones.tab1 ? 'none' : 'auto' }} className="nav-link text-light bg-blue-100 rounded" id="ex-with-icons-tab-1" data-mdb-toggle="tab" href="#ex-with-icons-tabs-1" role="tab" aria-controls="ex-with-icons-tabs-1" aria-selected="true"><i className="fas fa-briefcase fa-fw me-2" />Datos del Vendedor</a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a style={{ pointerEvents: botones.tab2 ? 'none' : 'auto' }} className="nav-link text-light bg-blue-200 rounded " id="ex-with-icons-tab-2" data-mdb-toggle="tab" href="#ex-with-icons-tabs-2" role="tab" aria-controls="ex-with-icons-tabs-2" aria-selected="false"><i className="fas fa-clipboard fa-fw me-2" />Clientes</a>
                    </li>
                  </ul>

                  <div className="tab-content" id="ex-with-icons-content" style={{ fontFamily: 'Times New Roman, Times, serif' }}>

                    <div className="tab-pane fade show active " id="ex-with-icons-tabs-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                    </div>

                    <div className="tab-pane fade" id="ex-with-icons-tabs-2" role="tabpanel" aria-labelledby="ex-with-icons-tab-2">


                    </div>



                  </div>
                </div>





              </div>

              <div className='col-md-12 mt-2'>
                {visibleBtn === 'visible' ? <div className='col-pd-600'>
                  <button disabled={botones.incluir} onClick={onBotones(1)} className="btn btn-sm mx-1 btn-primary rounded-pill" title='Incluir Almacen'><i className="fas fa-plus"> Incluir </i> </button>
                  <button disabled={botones.consultar} onClick={onBotones(4)} className="btn btn-sm mx-1 btn-info rounded-pill" title='Consultar Almacen' ><i className="fas fa-eye">Consultar</i> </button>
                  <button disabled={botones.modificar} onClick={onBotones(2)} className="btn btn-sm mx-1 btn-warning rounded-pill" title='Modificar Almacen'><i className="fa fa-edit">Modificar</i> </button>
                  <button disabled={botones.eliminar} onClick={onBotones(3)} className="btn btn-sm mx-1 btn-danger rounded-pill" title='Eliminar Almacen'><i className="fa fa-trash">Eliminar</i> </button>
                </div> : <div className='col-pd-340 d-flex justify-content-end mt-2 ml-auto'>
                  <button ref={btnAcepta} disabled={botones.aceptar} onClick={onBotones(5)} className="mx-2 btn btn-sm rounded-pill btn-success"><i className="fas fa-check-circle">  Aceptar</i></button>
                  <button ref={btnCancela} disabled={botones.cancelar} onClick={onBotones(6)} className="mx-2 btn btn-danger btn-sm rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
                </div>}                  
              </div>
            </div>

          </div>

        </div>
      </div >
      <CatalogoCuentaBancaria
        show={catalogoCuenta}
        onHideCancelar={() => { setCatalogoCuenta(false) }}
        onHideAceptaCatalogo={onCatalogoCuenta}
      />


      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
    </div>
  );
}
export default TablaConciliacion;


// WEBPACK FOOTER //
// ./src/components/finanzas/tablaConciliacion.js